"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MainSidebar_1 = require("./MainSidebar");
exports.default = MainSidebar_1.default;
//# sourceMappingURL=index.js.map